import { createFileRoute } from '@tanstack/react-router'
import WaterCharts from '@/components/field/insights/WaterCharts'
import DateRangePickerWithPresets from '@/components/inputs/DateRangePickerWithPresets'
import { RangeValue, DateValue, Alert } from '@heroui/react'
import { useState } from 'react'
import dayjs from 'dayjs'
import { parseDate } from '@internationalized/date'
import useFieldDashboard from '@/lib/fieldDashboard/useFieldDashboard'
import Upgrade from '@/components/enrollment/Upgrade'

export const Route = createFileRoute(
  '/dashboard/fields/$fieldId/insights/hydroflow',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { fieldIsMonitoring, fieldIsPreview, fieldQuery } = useFieldDashboard() ?? {};
  const [dateRange, setDateRange] = useState<RangeValue<DateValue> | null>({
    start: parseDate(dayjs().subtract(2, 'weeks').format('YYYY-MM-DD')),
    end: parseDate(dayjs().format('YYYY-MM-DD')),
  })

  return fieldIsMonitoring || fieldIsPreview ? (
    <div className="flex flex-row gap-2 items-center">
      <Alert
        color="warning"
        variant="flat"
        title="Monitoring Only"
        description="HydroFlow is not available for monitoring enrollments"
      />
      {fieldIsPreview && (
        <Upgrade name={fieldQuery?.data?.service_provider?.account_manager?.full_name} email={fieldQuery?.data?.service_provider?.account_manager?.email} />
      )}
    </div>
  ) : (
    <div className="flex flex-col gap-2">
      <DateRangePickerWithPresets
        value={dateRange}
        onChange={setDateRange}
        label="Date Range"
      />
      <WaterCharts dateRange={dateRange} />
    </div>
  );
}
